<h3 mat-dialog-title class="color-primary">{{ data.title }}</h3>

<div mat-dialog-content class="flex flex-col gap-[20px]">
	<mat-form-field class="w-full">
		<span matPrefix *ngIf="selectedData.tooltip && selectedData.tooltip !== ''">* &nbsp;</span>
		<input matInput type="text" maxlength="5" [(ngModel)]="selectedData.character" class="form-control"
			placeholder="{{'Character' | translate}}">
	</mat-form-field>
	<mat-form-field class="w-full">
		<!-- <mat-label>{{ "Tooltip" | translate }}</mat-label> -->
		<!-- <span matPrefix>* &nbsp;</span> -->
		<input matInput type="text" [(ngModel)]="selectedData.tooltip" class="form-control"
			placeholder="{{'Tooltip' | translate}}">
	</mat-form-field>
</div>
<div mat-dialog-actions align="end">
	<button mat-button (click)="closeModal(undefined)">{{data.cancelbtn}}</button>
	<button mat-flat-button (click)="submitData()">{{data.confirmbtn}}</button>
</div>